import { isRecord } from '~/utils/isRecord';

const ABSOLUTE_URL_PATTERN = /^https?:\/\//;

export function getCloudinaryImageId(
  source: unknown,
  options: { allowPlainString?: boolean } = {},
): string | undefined {
  if (options.allowPlainString && typeof source === 'string' && source.trim()) {
    return source.trim();
  }

  if (!isRecord(source)) {
    return undefined;
  }

  const imageId =
    source.publicImageId ||
    source.id_cloudinary_external ||
    source.logo_id_cloudinary_external ||
    source.idCloudinaryExternal ||
    source.imageId ||
    source.idImage ||
    source.cloudinaryId ||
    source.url ||
    source.imageUrl;

  return typeof imageId === 'string' && imageId.trim() ? imageId.trim() : undefined;
}

export function buildCloudinaryImageUrl(imageIdOrUrl: string, transform: string): string | undefined {
  if (ABSOLUTE_URL_PATTERN.test(imageIdOrUrl)) {
    return imageIdOrUrl;
  }

  const host = window.configs?.IMAGE_HOST;
  if (!host) {
    return undefined;
  }

  return `${host}/${transform}/${imageIdOrUrl}`;
}
